import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { isCapacitorNative, getCapacitorPlatform } from '../utils/capacitor';
import { syncHealthKitData } from '../services/healthKitSync';

export function useHealthKitAutoSync() {
  const ranRef = useRef(false);
  const { user } = useAuth();

  useEffect(() => {
    if (ranRef.current) return;
    if (!user?.healthkitConnected) return;
    if (!isCapacitorNative() || getCapacitorPlatform() !== 'ios') return;

    ranRef.current = true;

    syncHealthKitData(user?.garminConnected || false).catch(() => {
      // Silent — user can manually sync from Profile
    });
  }, [user?.healthkitConnected]);
}
